import React, { memo } from "react";
import TextField from "@mui/material/TextField";
import { getIpdSelectMenuProps, mergeIpdFieldSx } from "./ipdFieldStyles";

function IpdTextField({
  select = false,
  MenuProps,
  SelectProps,
  sx,
  size = "small",
  ...props
}) {
  const mergedSelectProps = select
    ? {
        ...SelectProps,
        MenuProps: getIpdSelectMenuProps(SelectProps?.MenuProps ?? MenuProps),
      }
    : SelectProps;

  return (
    <TextField
      select={select}
      size={size}
      sx={mergeIpdFieldSx(sx)}
      SelectProps={mergedSelectProps}
      {...props}
    />
  );
}

export default memo(IpdTextField);
